import { useEffect } from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import "./App.css";
import SignIn from "./pages/corporate/SignIn";
import SignUp from "./pages/corporate/SignUp";
import CorportateResister from "./pages/corporate/CorportateResister";
import Dashboard from "./pages/corporate/dashboard/Dashboard";
import MyEmployees from "./pages/corporate/dashboard/MyEmployees";
import Subscripiton from "./pages/corporate/dashboard/Subscripiton";
import DocumentManagement from "./pages/corporate/dashboard/DocumentManagement";
import ReportManagement from "./pages/corporate/dashboard/ReportManagement";
import CorporateProfile from "./pages/corporate/CorporateProfile";
import ProfSignIn from "./pages/professional/ProfSignIn";
import ProfSignUp from "./pages/professional/ProfSignUp";
import ProfUserRegisteration from "./pages/professional/ProfUserRegisteration";
import ProfMyServices from "./pages/professional/Profdashboard/MyServices";
import ProfSubscripiton from "./pages/professional/Profdashboard/ProfSubscripiton";
import ProfRatingReview from "./pages/professional/Profdashboard/ProfRatingReview";
import ProfChat from "./pages/professional/Profdashboard/ProfChat";
import ProfProfile from "./pages/professional/Profdashboard/ProfProfile";
import SampleSIgnIn from "./pages/sampleScreen/SampleSIgnIn";
import SampleSignUp from "./pages/sampleScreen/SampleSignUp";
import Home from "./pages/Home";
import ContactUs from "./pages/ContactUs";
import SearchFilterPage from "./pages/SearchFilterPage";
import SampleChat from "./pages/sampleScreen/sampleDashboard/SampleChat";
import SamplePorfilePage from "./pages/sampleScreen/sampleDashboard/SamplePorfilePage";
import SampleServices from "./pages/sampleScreen/sampleDashboard/SampleServices";
import SampleRating from "./pages/sampleScreen/sampleDashboard/SampleRating";
import SampleSetting from "./pages/sampleScreen/sampleDashboard/SampleSetting";
import SampleNotification from "./pages/sampleScreen/sampleDashboard/SampleNotification";
import ShareYourExperience from "./pages/sampleScreen/ShareYourExperience";
import SuperAdminDashboard from "./pages/superadmin/SuperAdminDashboard";
import SuperAdminProfessional from "./pages/superadmin/SuperAdminProfessional";
import SuperAdminChats from "./pages/superadmin/SuperAdminChats";
import SuperAdminSetting from "./pages/superadmin/SuperAdminSetting";
import SuperAdminReports from "./pages/superadmin/SuperAdminReports";
import SuperAdminCompanies from "./pages/superadmin/SuperAdminCompanies";
import SuperAdminPlans from "./pages/superadmin/SuperAdminPlans";
import CorporateNotifications from "./pages/corporate/dashboard/CorporateNotifications";
import CorporateSetting from "./pages/corporate/dashboard/CorporateSetting";
import ProfessionalSettings from "./pages/professional/Profdashboard/ProfessionalSettings";
import ProfNotification from "./pages/professional/Profdashboard/ProfNotification";
import EmailVarification from "./pages/EmailVarification";
import MySchedule from "./pages/professional/Profdashboard/MySchedule";
import MyProfile from "./pages/corporate/dashboard/MyProfile";
import UserEmailVarification from "./pages/UserEmailVarification";
import CorEmailValidation from "./pages/CorEmailValidation";
import ViewEmployee from "./pages/ViewEmployee";
import SampleSubscripiton from "./pages/sampleScreen/sampleDashboard/SampleSubscripiton";
import ProtectedRoute from "./privateroutes";
import UnauthorizedUser from "./components/unauthorized/UnauthorizedUser";
import { isAuthenticated, getUserRole } from "./privateroutes/auth";
import ForgorPassword from "./pages/ForgorPassword";
import ResetPassword from "./pages/ResetPassword";
import PublicRoute from "./privateroutes/publicRoutes";
import AddEmploye from "./components/AddEmployee/AddEmploye";
import UpdateEmployee from "./pages/corporate/dashboard/UpdateEmployee";
import EmployeChat from "./pages/employee/employeeDashboard/EmployeChat";
import EmployeProfile from "./pages/employee/employeeDashboard/EmployeProfile";
import EmployeeServices from "./pages/employee/employeeDashboard/EmployeeServices";
import EmployeeSubscription from "./pages/employee/employeeDashboard/EmployeeSubscription";
import EmployeeSettings from "./pages/employee/employeeDashboard/EmployeeSettings";
import EmployeeNotifications from "./pages/employee/employeeDashboard/EmployeeNotifications";
import EmployeeSchedule from "./pages/employee/employeeDashboard/EmployeeSchedule";
import SuperAdminUser from "./pages/superadmin/SuperAdminUser";
import CorporateVIewPage from "./pages/superadmin/CorporateVIewPage";
import EmployeeViewPage from "./pages/superadmin/EmployeeViewPage";
import ProfessionalViewPage from "./pages/superadmin/ProfessionalViewPage";
import UserViewPage from "./pages/superadmin/UserViewPage";
import EmailVarificationForSignUp from "./pages/EmailVarificationForSignUp";
import ProfileRewiew from "./pages/superadmin/ProfileReview";
import ProfileViewPage from "./pages/superadmin/ProfileViewPage";
import EmployeOwnServices from "./pages/employee/employeeDashboard/EmployeOwnServices";
import Pusher from "pusher-js";
import { showDesktopNotification } from "./constants/base";
import { useSelector } from "react-redux";
import SuccessPage from "./pages/SuccessPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import AboutUs from "./pages/AboutUs";
import ScrollToTop from "./components/scrollTopTop/ScrollToTop";
import ErrorPage from "./pages/ErrorPage";
import environment from "./config/config";

function App() {
  const userRole = getUserRole();
  const auth = useSelector((state) => state.AuthSlice.user);
  const subscriptionState = useSelector(
    (state) => state.AuthSlice.subscriptionState
  );

  useEffect(() => {
    const pusher = new Pusher("2e603f5ea3523f08e7b7", {
      cluster: "ap2",
    });

    const channel = pusher.subscribe("my-notify-channel");
    channel.bind("my-notify-event", (data) => {
      const newMessage = data.message;
      if (auth?.id == data?.message?.user_id) {
        showDesktopNotification(
          data?.message?.title,
          data?.message?.description
        );
      }
    });

    // Cleanup
    return () => {
      channel.unbind_all();
      channel.unsubscribe();
    };
  }, []);

  return (
    <>
      <BrowserRouter>
        <ScrollToTop />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route
            path="/find/services"
            element={
              <ProtectedRoute allowedRoles={["user"]} checkSubscription={false}>
                <SearchFilterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/email-varification"
            element={
              <PublicRoute>
                <EmailVarification />
              </PublicRoute>
            }
          />
          <Route
            path="/sign-up/email-varification"
            element={
              <PublicRoute>
                <EmailVarificationForSignUp />
              </PublicRoute>
            }
          />
          <Route path="/unauthorized" element={<UnauthorizedUser />} />
          <Route
            path="/forgot-password"
            element={
              <PublicRoute>
                <ForgorPassword />
              </PublicRoute>
            }
          />
          <Route
            path="/reset-password"
            element={
              <PublicRoute>
                <ResetPassword />
              </PublicRoute>
            }
          />

          <Route path="/payment/success" element={<SuccessPage />} />
          <Route path="/payment/error" element={<ErrorPage />} />

          <Route
            path="/service/provider/:id"
            element={
              <ProtectedRoute
                allowedRoles={[
                  "user",
                  "admin",
                  "professional",
                  "corporate",
                  "employe",
                ]}
                checkSubscription={true}
              >
                <CorporateProfile />
              </ProtectedRoute>
            }
          />

          <Route
            path="/signin"
            element={
              <PublicRoute>
                <SampleSIgnIn />
              </PublicRoute>
            }
          />

          <Route
            path="/privacy-policy"
            element={
              <PublicRoute>
                <PrivacyPolicy />
              </PublicRoute>
            }
          />
          <Route
            path="/terms-and-conditions"
            element={
              <PublicRoute>
                <TermsAndConditions />
              </PublicRoute>
            }
          />
          <Route
            path="/about-us"
            element={
              <PublicRoute>
                <AboutUs />
              </PublicRoute>
            }
          />

          {/*CORPORATE ROTUES*/}
          <Route path="/corporate">
            <Route
              path="signup"
              element={
                <PublicRoute>
                  <SignUp />
                </PublicRoute>
              }
            />
            <Route
              path="dashboard"
              element={
                <ProtectedRoute
                  allowedRoles={["corporate", "admin"]}
                  checkSubscription={true}
                >
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="employees"
              element={
                <ProtectedRoute
                  allowedRoles={["corporate", "admin"]}
                  checkSubscription={true}
                >
                  <MyEmployees />
                </ProtectedRoute>
              }
            />
            <Route
              path="employee/add"
              element={
                <ProtectedRoute
                  allowedRoles={["corporate", "admin"]}
                  checkSubscription={true}
                >
                  <AddEmploye />
                </ProtectedRoute>
              }
            />

            <Route
              path="employee/update/:id"
              element={
                <ProtectedRoute
                  allowedRoles={["corporate", "admin"]}
                  checkSubscription={true}
                >
                  <UpdateEmployee />
                </ProtectedRoute>
              }
            />

            <Route
              path="subscriptions"
              element={
                <ProtectedRoute
                  allowedRoles={["corporate", "admin"]}
                  checkSubscription={false}
                >
                  <Subscripiton />
                </ProtectedRoute>
              }
            />

            <Route
              path="notifications"
              element={
                <ProtectedRoute
                  allowedRoles={["corporate", "admin"]}
                  checkSubscription={true}
                >
                  <CorporateNotifications />
                </ProtectedRoute>
              }
            />

            <Route
              path="settings"
              element={
                <ProtectedRoute
                  allowedRoles={["corporate", "admin"]}
                  checkSubscription={true}
                >
                  <CorporateSetting />
                </ProtectedRoute>
              }
            />

            <Route
              path="profile"
              element={
                <ProtectedRoute
                  allowedRoles={["corporate", "admin"]}
                  checkSubscription={true}
                >
                  <MyProfile />
                </ProtectedRoute>
              }
            />
          </Route>

          {/* PROFESSIONAL ROUTES HERE */}
          <Route path="/professional">
            <Route
              path="signup"
              element={
                <PublicRoute>
                  <ProfSignUp />
                </PublicRoute>
              }
            />
            <Route
              path="services"
              element={
                <ProtectedRoute
                  allowedRoles={["professional", "admin"]}
                  checkSubscription={true}
                >
                  <ProfMyServices />
                </ProtectedRoute>
              }
            />
            <Route
              path="chat"
              element={
                <ProtectedRoute
                  allowedRoles={["professional", "admin"]}
                  checkSubscription={true}
                >
                  <ProfChat />
                </ProtectedRoute>
              }
            />
            <Route
              path="subscriptions"
              element={
                <ProtectedRoute
                  allowedRoles={["professional", "admin"]}
                  checkSubscription={false}
                >
                  <ProfSubscripiton />
                </ProtectedRoute>
              }
            />
            <Route
              path="feedbacks"
              element={
                <ProtectedRoute
                  allowedRoles={["professional", "admin"]}
                  checkSubscription={true}
                >
                  <ProfRatingReview />
                </ProtectedRoute>
              }
            />
            <Route
              path="profile"
              element={
                <ProtectedRoute
                  allowedRoles={["professional", "admin"]}
                  checkSubscription={true}
                >
                  <ProfProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="settings"
              element={
                <ProtectedRoute
                  allowedRoles={["professional", "admin"]}
                  checkSubscription={true}
                >
                  <ProfessionalSettings />
                </ProtectedRoute>
              }
            />
            <Route
              path="notifications"
              element={
                <ProtectedRoute
                  allowedRoles={["professional", "admin"]}
                  checkSubscription={true}
                >
                  <ProfNotification />
                </ProtectedRoute>
              }
            />
            <Route
              path="schedules"
              element={
                <ProtectedRoute
                  allowedRoles={["professional", "admin"]}
                  checkSubscription={true}
                >
                  <MySchedule />
                </ProtectedRoute>
              }
            />
          </Route>
          {/* PROFESSIONAL ROUTES HERE */}

          {/**************SAMPLE USER ROUTES**************/}
          <Route path="/user">
            <Route
              path="signup"
              element={
                <PublicRoute>
                  <SampleSignUp />
                </PublicRoute>
              }
            />
            <Route
              path="chat"
              element={
                <ProtectedRoute
                  allowedRoles={["user", "admin"]}
                  checkSubscription={true}
                >
                  <SampleChat />
                </ProtectedRoute>
              }
            />
            <Route
              path="profile"
              element={
                <ProtectedRoute
                  allowedRoles={["user", "admin"]}
                  checkSubscription={true}
                >
                  <SamplePorfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="availed/services"
              element={
                <ProtectedRoute
                  allowedRoles={["user", "admin"]}
                  checkSubscription={true}
                >
                  <SampleRating />
                </ProtectedRoute>
              }
            />
            <Route
              path="settings"
              element={
                <ProtectedRoute
                  allowedRoles={["user", "admin"]}
                  checkSubscription={true}
                >
                  <SampleSetting />
                </ProtectedRoute>
              }
            />
            <Route
              path="notificaitons"
              element={
                <ProtectedRoute
                  allowedRoles={["user", "admin"]}
                  checkSubscription={true}
                >
                  <SampleNotification />
                </ProtectedRoute>
              }
            />
            <Route
              path="rating"
              element={
                <ProtectedRoute allowedRoles={["user", "admin"]}>
                  <ShareYourExperience />
                </ProtectedRoute>
              }
            />
            <Route
              path="subscriptions"
              element={
                <ProtectedRoute
                  allowedRoles={["user", "admin"]}
                  checkSubscription={false}
                >
                  <SampleSubscripiton />
                </ProtectedRoute>
              }
            />
          </Route>

          {/****************SUPERADMIN ROUTES***************/}
          <Route path="/admin">
            <Route
              path="dashboard"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <SuperAdminDashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="professionals"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <SuperAdminProfessional />
                </ProtectedRoute>
              }
            />

            <Route
              path="users"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <SuperAdminUser />
                </ProtectedRoute>
              }
            />
            <Route
              path="corporates"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <SuperAdminCompanies />
                </ProtectedRoute>
              }
            />
            <Route
              path="settings"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <SuperAdminSetting />
                </ProtectedRoute>
              }
            />
            <Route
              path="reports"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <SuperAdminReports />
                </ProtectedRoute>
              }
            />
            <Route
              path="plans"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <SuperAdminPlans />
                </ProtectedRoute>
              }
            />
            <Route
              path="employees/:id"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <ViewEmployee />
                </ProtectedRoute>
              }
            />
            <Route
              path="employees/view/:id/:parent_id"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <EmployeeViewPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="corporate/view/:id"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <CorporateVIewPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="professional/view/:id"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <ProfessionalViewPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="user/view/:id"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <UserViewPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="profile/review"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <ProfileRewiew />
                </ProtectedRoute>
              }
            />
            <Route
              path="profile/view/:id"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <ProfileViewPage />
                </ProtectedRoute>
              }
            />
          </Route>

          {/****************EMPLOYEE ROUTES***************/}
          <Route path="/employee">
            <Route
              path="chat"
              element={
                <ProtectedRoute allowedRoles={["employee", "admin"]}>
                  <EmployeChat />
                </ProtectedRoute>
              }
            />
            <Route
              path="schedule"
              element={
                <ProtectedRoute allowedRoles={["employee", "admin"]}>
                  <EmployeeSchedule />
                </ProtectedRoute>
              }
            />
            <Route
              path="profile"
              element={
                <ProtectedRoute allowedRoles={["employee", "admin"]}>
                  <EmployeProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="feedbacks"
              element={
                <ProtectedRoute allowedRoles={["employee", "admin"]}>
                  <EmployeeServices />
                </ProtectedRoute>
              }
            />
            {/* <Route
              path="subscriptions"
              element={
                <ProtectedRoute allowedRoles={["employee", "admin"]}>
                  <EmployeeSubscription />
                </ProtectedRoute>
              }
            /> */}
            <Route
              path="settings"
              element={
                <ProtectedRoute allowedRoles={["employee", "admin"]}>
                  <EmployeeSettings />
                </ProtectedRoute>
              }
            />
            <Route
              path="services"
              element={
                <ProtectedRoute allowedRoles={["employee", "admin"]}>
                  <EmployeOwnServices />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
